// extracted by mini-css-extract-plugin
export default {"Loader-wrapper":"loader_Loader-wrapper__A+Ouk","loader":"loader_loader__HBwF-","Table":"loader_Table__jaS7J"};